import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CapitalizePipe } from './capitalize.pipe';
import { MomentDatePipe } from './moment-date.pipe';
import { MomentFromNowPipe } from './moment-from-now.pipe';
import { MomentDateCalendarPipe } from './moment-calendar.pipe';

const PIPES = [
  CapitalizePipe,
  MomentDatePipe,
  MomentFromNowPipe,
  MomentDateCalendarPipe,
];

@NgModule({
  declarations: [...PIPES],
  exports: [...PIPES],
  imports: [CommonModule],
})
export class PipesModule { }
